import React, { useState } from 'react';

import MainHeader from '../../ui-components/MainHeader';
import TopHeaderUi from '../../ui-components/TopHeaderUi';

import TaskView from './TaskView';
import CreateModal from './ProjectCreateModal';
import TaskDetails from './TaskDetails';
const TaskWrapper = () => {
	const [activeTab, setActiveTab] = useState('Task List');
	const uiTabs = ['Task List', 'Project Details', 'Create Modal'];
	const renderComponents = () => {
		switch (activeTab) {
			case 'Task List':
				return <TaskView />;

			case 'Create Modal':
				return <CreateModal />;
			case 'Project Details':
				return <TaskDetails />;
		}
	};
	return (
		<div className="content">
			<MainHeader />
			<div className="wraper container-fluid dashboard-container bg-gray">
				<TopHeaderUi activeTab={activeTab} setActiveTab={setActiveTab} tabs={uiTabs} />
				{renderComponents()}
			</div>
		</div>
	);
};

export default TaskWrapper;
